import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { UtilityHeader, Footer, SideNav, Logo } from '@awesomecomponents/mux';
import Form from './Form';
import { appConstants } from '../utils/appConstants';
import { BREAKPOINTS } from '@awesomecomponents/mux/core/spacing';
import { buildFooterMenus, buildHeaderRight } from '../utils/navigationBuilder';
import ExitModal from './ExitModal';
import TimeoutModal from './TimeoutModal';
const HeaderContainer = styled.div`
  position: relative;
`;

const Container = styled.div`
  position: absolute;
  top: 150px;
  left: 100px;
  right: 0;
  bottom: 0;
  overflow: auto;
  background-color: #fafafa;

  @media (max-width: ${BREAKPOINTS.MAX_1600}px) {
    left: 80px;
  }

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    top: 60px;
    left: 0;
  }
`;

const Content = styled.div`
  position: relative;
  min-height: calc(100vh - 250px);
  background-color: #fafafa;
`;

const LogoContainer = styled.div`
  position: fixed;
  top: 40px;
  right: 0;
  left: 100px;
  bottom: 0;
  width: 100%;
  height: 150px;
  overflow: auto;
  background-color: #fafafa;

  @media (max-width: ${BREAKPOINTS.MAX_1600}px) {
    left: 80px;
  }

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    top: 0;
    left: 0;
  }
`;

const Clickable = styled.div`
  position: relative;
  width: 114px;
  height: 26px;
  cursor: pointer;
`;

const UtilityClickable = styled.div``

const SideNavWrapper = styled.div`
  & nav {
    overflow-y: hidden;
  }
`;

const customStyle = {
  logoWrapperStyle: {
    width: '8%',
    height: '9%',
    margin: '30px 30px',
    media: {
      [BREAKPOINTS.MAX_768]: {
        display: 'none',
      },
    },
  },
  imageStyle: {
    width: '114px',
    height: '26px',
  },
};

const UnAuthFlow = ({ business_unit, form_name, lang, langContent }) => {
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  const { EXIT, IDLE_TIMER, IDLE_TIMER_REMAINING, INTERVAL_TIME, DEBOUNCE_TIME, FLOW_UNAUTH } = appConstants;
  return (
    <Fragment>
      <HeaderContainer>
        {window.innerWidth < BREAKPOINTS.MAX_768 ? (
          <UtilityClickable onClick={setIsExitModalOpen}>
            <UtilityHeader
              rightItems={buildHeaderRight(lang)}
              rightMobileItems={buildHeaderRight(lang)}
              showLangToggle={false}
              showSignin={false}
              lang={lang}
            />
          </UtilityClickable>
        ) : (
          <UtilityHeader
            rightItems={buildHeaderRight(lang)}
            rightMobileItems={buildHeaderRight(lang)}
            showLangToggle={false}
            showSignin={false}
            lang={lang}
          />
        )}
        <SideNavWrapper>
          <SideNav lang={lang} brandLink={() => setIsExitModalOpen(true)} />
        </SideNavWrapper>
      </HeaderContainer>
      {window.innerWidth > BREAKPOINTS.MAX_768 && (
        <LogoContainer>
          <Clickable>
            <Logo
              alt="Manulife"
              onClick={setIsExitModalOpen}
              lang={lang}
              variant="black_wordmark"
              customStyle={customStyle}
            />
          </Clickable>
        </LogoContainer>
      )}
      <Container id="mainContainer">
        <TimeoutModal
          lang={lang}
          langContent={langContent}
          isAuthenticated={false}
          IDLE_TIMER={IDLE_TIMER}
          IDLE_TIMER_REMAINING={IDLE_TIMER_REMAINING}
          INTERVAL_TIME={INTERVAL_TIME}
          DEBOUNCE_TIME={DEBOUNCE_TIME}
        >
          <Content data-testid="content">
            <Form
              business_unit={business_unit}
              form_name={form_name}
              flow={FLOW_UNAUTH}
              langContent={langContent}
              lang={lang}
              isAuthenticated={false}
              setIsExitModalOpen={setIsExitModalOpen}
            />
          </Content>
          <Footer items={buildFooterMenus(lang)} lang={lang} />
        </TimeoutModal>
      </Container>
      <ExitModal
        lang={lang}
        isExitModalOpen={isExitModalOpen}
        onExitModalCloseHandler={() => setIsExitModalOpen(false)}
        langContent={langContent[EXIT]}
        isAuthenticated={false}
        setIsExitModalOpen={setIsExitModalOpen}
      />
    </Fragment>
  );
};

export default UnAuthFlow;
